<div class="flex-wrap">
        <div class="col-lg-9">
            <mat-card class="content">
                <p i18n  class="title">SHOPPING CART CONTENTS</p>
                <div class="table-container">
                    <div class="article-info-container">
                        <div class="attribute-info-container">
                            <h2 i18n>Product: </h2>
                            <div *ngFor="let attribute of article['attributes']; let i = index" class="attribute-field">  
                                <p i18n class="attribute-name">{{attribute.attributeName}}:   </p> <p i18n >{{attribute.attributeValue}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="quantity">     
                        <div class="input-group mb-4" style="width: 100px; margin: auto;">
                            <div class="input-group-prepend">
                            <button i18n class="input-group-text" (click)="minus()">-</button>
                            </div>
                            <input type="text" class="form-control" [value]="article.quantity" disabled>
                            <div class="input-group-append">
                            <button i18n class="input-group-text" (click)="plus()">+</button>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-card>
        </div>
    <div class="col-lg-3">
        <mat-card class="price-box">
            <div class="row">
                <label class="col-lg-6">TOTAL</label>
                <div class="col-lg-6"><p><app-currency-converter [data]="{price:totalPrice, country: null}"></app-currency-converter></p> </div>
            </div>
        </mat-card>
        <mat-card class="place-order">
            <div class="form-group form-check">
                <input type="checkbox" class="form-check-input" id="term" [(ngModel)]="terms">
                <label i18n class="form-check-label" for="term">I accept the <a href="https://ancytree.com/allmanna-kopvillkor/" target="_blank">Terms and Conditions</a> and <a href="https://ancytree.com/privacy-policy/" target="_blank">the privacy policy</a></label>
            </div>

            <button i18n (click) = "checkout()" [disabled]="!terms"> NEXT </button>
        </mat-card>
    </div>
</div>